import { IUnitDetailsDto } from 'api/api';
import React, { FC, memo } from 'react';
import { localized } from 'state/i18n';
import { IdDataTuple } from 'utilities/types-util';
import WhiteCard from 'view/shared/components/cards/white-card';
import { getDateToString } from 'view/shared/components/date-to-string';
import LabelValueCard, {
	addTranslationLabelValueMapToList,
	getLabelValueOrDefaultToLocalizedNoDataString,
	LabelValueForCardMap,
} from 'view/shared/components/label-value-card';
import {
	cardDetailsStyles,
	cardGeneralClassNames,
	cardGraphStyles,
	targetMapHeight,
	targetMapWidth,
} from '../constants';
import BiMap from './bi-map';
import BleTagSourceIndicator from './ble-tag-source-indicator';

interface Props {
	currMachine: IdDataTuple<IUnitDetailsDto, string>;
	latitude?: string;
	longitude?: string;
}

const getLocationPairValues = (currMachine: IdDataTuple<IUnitDetailsDto, string>) => {
	const retMap: LabelValueForCardMap = {
		labels: [],
		valuesForLabels: [],
	};

	if (currMachine?.data?.lastTrackerUpdate) {
		addTranslationLabelValueMapToList(
			'updatedDateFriendly',
			getLabelValueOrDefaultToLocalizedNoDataString(getDateToString(currMachine.data.lastTrackerUpdate)),
			retMap,
			false
		);
	}

	return retMap;
};

export const LocationCard: FC<Props> = memo(props => {
	const { currMachine, latitude, longitude } = props;
	const { gpsLocation, gpsHomeLocation, id } = currMachine.data;
	const locationPairValues = getLocationPairValues(currMachine);

	if (!currMachine || !((gpsLocation && gpsLocation.length) || (gpsHomeLocation && gpsHomeLocation.length))) {
		return null;
	}

	const labelValues = locationPairValues.labels.length > 0 && (
		<div className="label-values-card-container">
			<LabelValueCard labels={locationPairValues.labels} values={locationPairValues.valuesForLabels} />
		</div>
	);

	const containerClassName = `${cardGeneralClassNames.classNameContainer} ${cardDetailsStyles.classNameContainer} card-container-no-padding`;

	const title = (
		<span className="flex-direction-row flex-center-column">
			{gpsLocation && gpsLocation.length ? localized('gpsLocation') : localized('HomeLocation')}
			<BleTagSourceIndicator
				show={!!currMachine.data.connectedBleTagMac}
				connectedBleTagMac={currMachine.data.connectedBleTagMac}
				translationKey="LocationFromBleTagDeviceInt"
				wrapperClassName="margin-left-20px"
			/>
		</span>
	);

	return (
		<div className="flex-container-forcing">
			<WhiteCard title={title} classNameTitle={'padding-32px'} classNameContainer={containerClassName}>
				{labelValues}
				<BiMap
					height={`${targetMapHeight}`}
					width={`${targetMapWidth}`}
					gpsLocation={{
						latitude: latitude,
						longitude: longitude,
					}}
					machineDetailsId={id}
					classNameContainer={`${cardGraphStyles.classNameContainer} card-padding-0 card-width-big-square margin-top-15px card-height-auto display-inherit border-shadow-dark-all-corners`}
					fillLevel={currMachine.data.fillLevel}
					hasModem={currMachine.data.hasModem}
					isOnline={currMachine.data.isOnline}
				/>
			</WhiteCard>
		</div>
	);
});
